import { jsx as _jsx } from "react/jsx-runtime";
import { _className, ComponentSync } from '@nu-art/thunderstorm-frontend';
import './Component_TimeSinceTriageV2.scss';
import { ModuleFE_EncounterMetadata, ModuleFE_RuntimeProtocol } from '@app/advisor-frontend';
import { Day, Hour, Minute, numberInRange } from '@nu-art/ts-common';
export class Component_TimeSinceTriageV2 extends ComponentSync {
    //######################### Life Cycle #########################
    __onEncounterMetadataUpdated = () => {
        this.reDeriveState();
    };
    deriveStateFromProps(nextProps, state) {
        const metadata = ModuleFE_EncounterMetadata.getEncounterMetadata();
        const generalProtocol = ModuleFE_RuntimeProtocol.getGeneralProtocol();
        state.encounterTimestamp = metadata?.period?.start ?? metadata?.__created ?? generalProtocol?.__created ?? 0;
        return state;
    }
    //######################### Logic #########################
    getClassName = () => {
        let delta = Date.now() - this.state.encounterTimestamp;
        const hours = Math.floor(delta / Hour);
        return _className('time-since-triage-v2', numberInRange(hours, [4, 5]) && 'warn', numberInRange(hours, [6, Infinity]) && 'critical');
    };
    getTimeString = () => {
        if (!this.state.encounterTimestamp)
            return 'N/A';
        let delta = Date.now() - this.state.encounterTimestamp;
        const days = Math.floor(delta / Day);
        delta = delta - (days * Day);
        const hours = Math.floor(delta / Hour);
        delta = delta - (hours * Hour);
        const minutes = Math.floor(delta / Minute);
        return days
            ? `${days}d ${hours}h ${minutes}m`
            : hours
                ? `${hours}h ${minutes}m`
                : `${minutes}m`;
    };
    //######################### Render #########################
    render() {
        return _jsx("div", { className: this.getClassName(), children: this.getTimeString() });
    }
}
//# sourceMappingURL=Component_TimeSinceTriageV2.js.map